import { render, staticRenderFns } from "./ZoneInfoDetail.vue?vue&type=template&id=33767183"
import script from "./ZoneInfoDetail.vue?vue&type=script&lang=js"
export * from "./ZoneInfoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports